// extracted by mini-css-extract-plugin
export default {"SMBCFormContainer":"SMBCForm_SMBCFormContainer__bI8Vi","payForm":"SMBCForm_payForm__Dfi+S","submitButton":"SMBCForm_submitButton__lxbrc"};